const store = {
    key: "",
    message: ""
};
export default store;
